<template>
  <div class="product_zx product_zxinfo">
    <!-- 产品中心详情 -->
    <!-- nav -->
    <index-nav></index-nav>
    <!-- bottom -->
    <index-bottom></index-bottom>
    <div class="content">
      <!-- banner -->
      <div class="banner">
        <img src="/statics/images/info/cp_banner.png" alt />
      </div>
      <!-- 总导航 -->
      <div class="allnav inner">
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                    <el-tab-pane label="通风系列产品" name="0" disabled></el-tab-pane>
                    <!-- <el-tab-pane label="电厂系列产品" name="1" disabled></el-tab-pane> -->
                </el-tabs>
      </div>
      <!-- <div class="allnav inner">
        <div></div>
        <div></div>
      </div> -->
      <div class="chanpincon">
        <div class="inner">
          <!-- 产品用途 -->
          <div class="cpyt">
            <h3>产品介绍</h3>
            <div v-html="content">内容</div>
          </div>
          <!-- 推荐产品 -->
          <div class="tjcp">
            <div class="top">
              <span>推荐产品</span>
            </div>
            <div
              class="tj_item"
              v-for="(item,index) in goodsInfo.recommend_list"
              :key="index"
              @click="toCp_info(item.id)"
            >
              <div class="pic">
                <img :src="adddom(item.thumb)" alt />
              </div>
              <div class="title">
                <span>{{item.name}}</span>
              </div>
              <div class="more">
                <span>查看详情</span>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- bottom -->
    <!-- <index-bottom></index-bottom> -->
    <!-- footer -->
    <index-footer></index-footer>
  </div>
</template>

<script>
import indexNav from "./../components/nav";
import indexBottom from "./../components/bottom";
import indexFooter from "./../components/footer";
export default {
  data() {
    return {
      activeName: "0",
      cp_id: "",
      content:"",//富文本
      goodsInfo: {
        detail:{
          content:""
        }
      } //产品详情
    };
  },
  components: {
    indexNav,
    indexBottom,
    indexFooter
  },
  created() {
    this.cp_id = this.$route.query.id;
    var cate = this.$route.query.cate;
    this.activeName = cate;
    this.getInfo();
  },
  methods: {
    // 图片拼接地址
    adddom(src) {
      if (src == "" || src == undefined || src == null) {
        console.log("src地址有问题");
        return "";
      }
      if (src.substr(0, 4).toLowerCase() === "http") {
        return src;
      }
      return this.$url + src;
    },
    getInfo() {
      var that = this;
      var ps = {
        id: that.cp_id
      };
      that.$api.index.goodsDetail(ps).then(function(res) {
        if (res.code == 200) {
          that.goodsInfo = res.result;
           that.content = res.result.detail.content.replace(
            /\<img src\=\"\upload/g,
            '<img class="fupic" src="' + that.$url + "/upload"
          );
        }
      });
    },
    // 总导航选中触发
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 跳转到产品中心详情
    toCp_info(id) {
      this.$router.push({
        path: "/product_zxinfo",
        query: {
          cate:this.activeName,
          id: id
        }
      });
    }
  },
  watch: {
    // $route(to, from) {
    //   console.log("to",to);
    //   console.log("from",from);
    //   if(to.name == "product-zxinfo"){
    //     location.reload(); //刷新页面
    //   }
    // }
  },
  mounted: function() {}
};
</script>

<style>
</style>